import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    IconButton,
    List,
    ListItem,
    makeStyles,
    Menu,
    MenuItem,
    Typography,
} from "@material-ui/core"
import { Add, ExpandMore, MoreVert } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { memo, useCallback, useMemo, useState } from "react"
import { useCardapioContext } from "./CardapioContext"
import ItemAdicional from "./ItemAdicional"

const ITEM_HEIGHT = 48

const useStyles = makeStyles({
    container: {
        width: "100%",
    },
    lista: {
        width: "100%",
        "& > *:nth-child(even)": {
            backgroundColor: "rgba(255,0,255,0.04)",
        },
    },
    cadastrarItem: {
        height: "50px",
        display: "flex",
        justifyContent: "space-between",
    },
    botaoSalvar: {
        backgroundColor: "#14A44D",
        color: "white",
    },
    // dragIndicator: {
    //     cursor: "move",
    // },
})

const ItemPasso = memo(function ItemPasso({ opcao, conteudo }) {
    const {
        setCadastrar,
        setModalPasso,
        setOpenPassoDeMontagem,
        setProdutoAtual,
        handleExcluirGrupoDeOpcao,
        handleToggleDuplicarGrupoDeMontagem,
        handleCadastrarOpcao,
    } = useCardapioContext()

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [anchorEl, setAnchorEl] = useState(null)
    const openMoreItemDeMontagem = Boolean(anchorEl)

    const handleClickMoreItemDeMontagem = useCallback(e => {
        setAnchorEl(e.currentTarget)
        e.stopPropagation()
    }, [])

    const handleCloseMoreItemDeMontagem = useCallback(e => {
        setAnchorEl(null)
        e.stopPropagation()
    }, [])

    const classes = useStyles()

    const handleClickPassoDeMontagem = useCallback(() => {
        setOpenPassoDeMontagem(true)
    }, [setOpenPassoDeMontagem])

    // const handleDragStart = index => {
    //     setDraggingOpcoes(index)
    // }
    // const handleDragEnd = () => {
    //     setDraggingOpcoes(null)
    // }

    const [expanded, setExpanded] = useState(false)

    const handleExpansion = useCallback(() => {
        setExpanded(prevExpanded => !prevExpanded)
    }, [])

    const opcoesOrdenados = useMemo(() => {
        if (!expanded) return []
        const o = opcao?.opcoes ?? []
        return [...o].sort((a, b) => a.ordemExib - b.ordemExib)
    }, [opcao?.opcoes, expanded])

    const handleClickAdicionarItem = useCallback(() => {
        handleCadastrarOpcao(conteudo?.id, opcao?.id)
    }, [handleCadastrarOpcao, conteudo?.id, opcao?.id])

    return (
        <Accordion className={classes.container} expanded={expanded} onChange={handleExpansion}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Grid container alignItems="center">
                    <Typography>{opcao?.nome}</Typography>
                </Grid>
                <IconButton onClick={handleClickMoreItemDeMontagem}>
                    <MoreVert fontSize="small" />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={openMoreItemDeMontagem}
                    onClose={handleCloseMoreItemDeMontagem}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: "20ch",
                        },
                    }}
                >
                    <MenuItem
                        onClick={e => {
                            e.stopPropagation()
                            handleClickPassoDeMontagem()
                            setCadastrar(false)
                            setModalPasso(opcao)
                            setProdutoAtual(conteudo)
                        }}
                    >
                        Editar Passo
                    </MenuItem>
                    <MenuItem
                        onClick={e => {
                            e.stopPropagation()
                            handleToggleDuplicarGrupoDeMontagem(opcao.id)
                        }}
                    >
                        Duplicar Passo
                    </MenuItem>
                    <MenuItem
                        onClick={e => {
                            e.stopPropagation()
                            handleExcluirGrupoDeOpcao(conteudo?.id, opcao?.id)
                        }}
                    >
                        Excluir Passo
                    </MenuItem>
                </Menu>
            </AccordionSummary>
            {expanded && (
                <AccordionDetails>
                    <List className={classes.lista}>
                        <ListItem divider className={classes.cadastrarItem}>
                            <Typography>Cadastrar Item</Typography>
                            <Grid>
                                <IconButton onClick={handleClickAdicionarItem}>
                                    <Add />
                                </IconButton>
                            </Grid>
                        </ListItem>
                        {opcoesOrdenados.map(item => (
                            <ListItem key={item?.id} divider>
                                <ItemAdicional produto={conteudo} passo={opcao} item={item} />
                            </ListItem>
                        ))}
                    </List>
                </AccordionDetails>
            )}
        </Accordion>
    )
})

export default ItemPasso
